var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect } from 'react';
const FIRST_PAGE = 1;
export const useKeepPageInRange = (pagination, isLoading) => {
    _react_refresh_temp_1();
    const pageCount = pagination
        ? Math.ceil(pagination.totalItems / pagination.pageSize)
        : 0;
    const lastPage = Math.max(pageCount, FIRST_PAGE);
    const pageChange = pagination?.pageChange;
    // Callers report 0 items while a page is loading, so only act on loaded, non-empty data.
    const isPageOutOfRange = pageChange !== undefined &&
        !isLoading &&
        pageCount > 0 &&
        pagination !== undefined &&
        pagination.currentPage > lastPage;
    useEffect(() => {
        if (isPageOutOfRange) {
            pageChange(lastPage);
        }
    }, [isPageOutOfRange, lastPage, pageChange]);
    return { hasPager: pageCount > 1, isPageOutOfRange };
};
_react_refresh_temp_1(useKeepPageInRange, "OD7bBpZva5O2jO+Puf00hKivP7c=");
